import { render, staticRenderFns } from "./ServiceProviderOffers.vue?vue&type=template&id=c67f55a8&"
import script from "./ServiceProviderOffers.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderOffers.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProviderOffers.vue?vue&type=style&index=0&id=c67f55a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports